import React, {useMemo, useRef, useState} from "react";
import TablePage from "../../pages/tablePage/TablePage";
import CountryEditModal from "./CountryEditModal";
import {useCountryData} from "./useCountryData";
import IsLoading from "../../shared/components/IsLoading";
import ErrorPage from "../../shared/components/ErrorPage";

const Country = () => {
    const [rowData, setRowData] = useState({});
    const refreshRef = useRef(null);
    const { data: countryData, isLoading, error } = useCountryData();

    const columns = useMemo(() => ([
        {title: 'Country Code', dataIndex: 'countryCode', key: 'countryCode', search: true},
        {title: 'Language Code', dataIndex: 'langCode', key: 'langCode', search: true},
        {title: 'Country Name', dataIndex: 'countryName', key: 'countryName', search: true},
        {title: 'Language Name', dataIndex: 'languageName', key: 'languageName', search: true},
    ]), []);

    if (isLoading) return <IsLoading />;
    if (error) return <ErrorPage error={error} />;

    const props = {
        columns,
        rowData,
        setRowData,
        refreshRef,
        modal: CountryEditModal,
        buttonText: '국가/언어 추가',
        localData: countryData,
    }

    return (
        <TablePage {...props}/>
    )
}

export default Country;